import type { ActivityDefinition } from "@medplum/fhirtypes";
import { ACTIVITY_DEFINITION_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to ActivityDefinition resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useActivityDefinitionSubscription = createSubscriptionHook<ActivityDefinition>(
  "ActivityDefinition",
  ACTIVITY_DEFINITION_COLLECTION_NAME,
);
